export const jaJP = {
  // 入金関連
  deposit: {
    title: '入金',
    chain: 'チェーン',
    asset: '資産',
    amount: '数量',
    available: '利用可能',
    equity: '総資産',
    confirmDeposit: '入金確認',
    switchNetwork: 'ネットワークを切り替え',
    max: '最大',
    arrivalTime: '着金予定時間',
    minDeposit: '最低入金額',
    minDepositParsed: '最低入金額 {{amount}} {{token}}',
    maxDeposit: '最大入金額',
    depositTipFor25w:
      '1回の入金上限額は200,000です。200,000を超える場合は、Ethereumチェーンでの入金をご利用ください。',
    depositAllTip:
      'このアドレスは{{coin}}（{{v}}）専用です。他通貨は送金しないでください。\n 入金金額が 200,000 を超える場合、反映までに時間がかかることがあります。しばらくお待ちください。',
    enableSystemProWithToken: '{{network}} 上で {{token}} を有効化',
    enableTokenDesc:
      '初めて {{network}} に入金する際は、{{token}} の有効化が必要です。',
    enableWithToken: '{{token}} を有効化',
    arrivaltimeTooltip1:
      '資金は約 {{v}} 分以内（{{v1}} 回のブロック確認が完了後）に到账します。',
    arrivaltimeTooltip2:
      '着金時間は過去データに基づいた目安であり、ネットワーク状況により遅延する場合があります。',
    arrivalEstimated: '≈ {{v}}分',
    availableDesc:
      '入金可能な最大金額。利用可能残高が0または負の数の場合、入金はできません。',
    noPrivateKeyWalletWarning:
      '秘密鍵のないウォレットでの入金は行わないでください。そのような入金は資金を失い、取り戻すことができません。',
    layerZeroDepositTip:
      'システムは入金資金の実際の状況に基づき、LayerZeroを通じて入金を完了します。',
    layerZeroDepositTipExceedPool:
      '入金額がプールを超えているため、LayerZero を通じて入金が完了します。',
    layerZeroDepositTipGte200k:
      '入金額が 200,000 USDT 以上のため、LayerZero を通じて入金が完了します。',
    layerZeroDepositButton: 'LayerZeroで入金',
  },
  withdraw: {
    noticeDesc:
      '通常出金は2ステップで行われます。このステップで出金リクエストを送信し、Layer2で処理されます。資金の準備が完了すると（最大4時間かかる場合があります）、出金の通知が届きます。チェーンの同期などの影響により、所要時間は最長で48時間かかる場合があります。ガス代はユーザー負担です。',
    crossChainTips:
      'クロスチェーン出金はL2上（ゼロ知識証明経由）で検証が必要です。出金処理には最大2時間ほどかかる場合があります。対応するチェーンの資産プールに十分な流動性が必要であり、ガス代も発生します。edgeXはそのコストを補うため、一定の手数料を徴収します。',
    commonWithdraw: '出金ガイド',
    withdraw: '出金',
    speed: '出金時間',
    confirmWithdraw: '出金確認',
    speedNote: '処理時間：',
    speedNoteSpeed1: '約8分',
    speedNoteSpeed2: '約2～4時間',
    speedNoteSpeed3: '約4時間',
    receiverAddress: '受取アドレス',
    fee: '手数料',
    feeRate: '手数料率',
    withdrawlAmount: '出金額',
    amountToReceive: '受け取り金額',
    invalidReceiverAddress: 'ウォレットアドレスは必須です',
    availableDesc:
      '引き出し可能な最大金額。利用可能残高が0または負の数の場合、引き出しはできません。',
    feeCalculationTip:
      '出金手数料は、出金金額に料率を乗じて計算され、最低1 USDT/USDCとなります。料率は、ブロックチェーンの実際の状況に基づいて調整される場合があります。',
    crossChainPoolBalance: 'クロスチェーンプール残高',
    poolBalance: 'プール残高',
    poolBalanceInsufficientTip:
      '出金額が資金プールの残高を上回っているため、出金は処理できません。資金プールの残高が十分にあるオプションを選択してください。',
  },
  account: {
    title: 'アカウント',
    perpetual: 'パーペチュアルアカウント',
    spot: 'スポットアカウント',
  },
}

export default jaJP
